import { Box } from "@chakra-ui/react";
import { call, colors, customEvent, getCdnImageSrc, Spacing } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import { MUBINSO_GUIDE_BOOKS, MUBINSO_GUIDE_FALLBACK_IMG, MUBINSO_PHONE } from "./mubinsoConstants";
import { MubinsoCtaButton, MubinsoScreenLayout } from "./MubinsoUI";
import { MubinsoScreenChromeContext } from "./mubinsoScreenChromeContext";
import { useContext, useEffect } from "react";

/**
 * 리드 제출 완료 후 최종 가이드 화면.
 * 전화 연결 CTA + 가이드북 팁 썸네일 2개(가이드북 목록과 동일한 embed 이미지).
 */
export default function MubinsoGuideScreen() {
  // 제출 완료 화면에서는 이탈 방지 해제(가이드북 링크·전화 연결이 모달/네이티브 경고에 막히지 않도록).
  const chrome = useContext(MubinsoScreenChromeContext);
  useEffect(() => {
    chrome?.setPreventLeave(false);
    return () => chrome?.setPreventLeave(true);
  }, [chrome]);

  return (
    <MubinsoScreenLayout>
      <Box width="100%" whiteSpace="pre-line" className="head2_b black">
        {"신청이 접수되었어요.\n필요한 정보를 더 확인해보세요"}
      </Box>
      <Spacing gap={12} />
      <Box width="100%" className="body_16_r gray600">
        급하시면 바로 전화로 안내해드릴게요.
      </Box>

      <Spacing gap={24} />
      <MubinsoCtaButton
        label={`전화 연결하기 ${MUBINSO_PHONE}`}
        onClick={() => {
          customEvent({ newGtm: { path: "mubinso_funnel", trigger_and_target: "guide-call" } });
          call(MUBINSO_PHONE);
        }}
      />

      <Spacing gap={40} />
      <Box width="100%" className="subtitle_14_b gray900">
        무빈소 장례 가이드
      </Box>
      <Spacing gap={16} />
      <BaseStack width="100%" spacing={16}>
        {MUBINSO_GUIDE_BOOKS.map((book) => (
          <Box
            key={book.href}
            as="a"
            href={book.href}
            display="block"
            width="100%"
            borderRadius="12px"
            overflow="hidden"
            border={`1px solid ${colors.gray200}`}
            cursor="pointer"
            onClick={() => {
              customEvent({
                newGtm: { path: "mubinso_funnel", trigger_and_target: book.eventTarget },
              });
            }}
          >
            {/* onError 폴백 + 원본 비율 유지가 필요해 next/image 대신 img 사용 */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={getCdnImageSrc(book.thumbnail)}
              alt={book.alt}
              onError={(e) => {
                const img = e.currentTarget;
                if (img.dataset.fallback) return;
                img.dataset.fallback = "1";
                img.src = getCdnImageSrc(MUBINSO_GUIDE_FALLBACK_IMG);
              }}
              style={{ width: "100%", display: "block", backgroundColor: colors.gray100 }}
            />
          </Box>
        ))}
      </BaseStack>
      <Spacing gap={80} />
    </MubinsoScreenLayout>
  );
}
